import { render, staticRenderFns } from "./PanelPlans.vue?vue&type=template&id=6d5c5914&scoped=true&"
import script from "./PanelPlans.vue?vue&type=script&lang=js&"
export * from "./PanelPlans.vue?vue&type=script&lang=js&"
import style0 from "./PanelPlans.vue?vue&type=style&index=0&id=6d5c5914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5c5914",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VLayout,VProgressLinear,VSlideYTransition})
